import React from 'react';
import { Box, Grid, Typography, Paper, Stack } from '@mui/material';
import SectionTitle from '../common/SectionTitle';
// 🖼️ Import step images
import InitialCall from '../Assets/Images/New Images/InitialCall.jpg';
import SiteInspection from '../Assets/Images/New Images/SiteInspection.jpg';
import Sketching from '../Assets/Images/New Images/SketchinginXactimate.jpg';
import Scopes from '../Assets/Images/New Images/Scope.jpg';
import CostEstimation from '../Assets/Images/New Images/CostEstimation.jpg';
import Report from '../Assets/Images/New Images/Report.jpg';
import Authorization from '../Assets/Images/New Images/Authorzation.jpg';
import QualityCheck from '../Assets/Images/New Images/QualityCheck.jpg';
import FinalBilling from '../Assets/Images/New Images/FinalBilling.jpg';

  const steps = [
    { title: 'Initial Call', desc: 'Immediate tips and dispatch.', img: InitialCall },
    { title: 'Site Inspection', desc: 'Safety checks and moisture readings.', img: SiteInspection },
    { title: 'Sketching in Xactimate', desc: 'Measure rooms and walls (L×W, H×W).', img: Sketching },
    { title: 'Scopes', desc: 'Define demolition, cleaning, and drying.', img: Scopes },
    { title: 'Cost Estimation', desc: 'Xactimate codes, O&P, after-hours.', img: CostEstimation },
    { title: 'Report', desc: 'Photos, moisture logs, equipment logs.', img: Report },
    { title: 'Authorization', desc: 'Work authorization & DTP.', img: Authorization },
    { title: 'Quality Check', desc: 'Daily monitoring and adjustments.', img: QualityCheck },
    { title: 'Final Billing', desc: 'Invoice and documentation packet.', img: FinalBilling }
  ];

const BookingStepsSection = () => {
  return (
    <Box sx={{ py: { xs: 8, md: 10 } }}>
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: 2 }}>
        <SectionTitle
          overline="How it works"
          title="Our 9-Step Restoration Process"
          subtitle="No phone tag or long email threads. Book your service online in just a couple of minutes."
          align="center"
        />

        <Grid container spacing={4}>
          {steps.map((step, index) => (
            <Grid key={step.title} item xs={12} md={4}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 1,
                  backgroundColor: '#ffffff',
                  boxShadow: '0 10px 30px rgba(15, 23, 42, 0.06)'
                }}
              >
                <Stack direction="row" spacing={2} alignItems="flex-start">
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: '50%',
                      backgroundColor: 'rgba(31,186,104,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700,
                      color: 'primary.main'
                    }}
                  >
                    {index + 1}
                  </Box>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                      {step.title}
                    </Typography>
                        <Box
  component="img"
  src={step.img}
  alt={step.title}
  sx={{
    width: '100%',
    height: 160,
    objectFit: 'cover',
    borderRadius: 1,
    transition: 'transform 0.3s ease',

    '&:hover': {
      transform: 'scale(1.05)',
    },
  }}
/>

                    <Typography variant="body2" color="text.secondary">
                      {step.desc}
                    </Typography>
                  </Box>
                </Stack>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default BookingStepsSection;
